// extracted by mini-css-extract-plugin
export default {"cardHeader":"custom-list_cardHeader__Kdt8Z","list":"custom-list_list__WBr+8"};